const { map, compose, join, toPairs, filter, trim } = require('ramda')

const DEFAULT_EMPLOYMENT_FILTERS = 'employment_type:\'Year Round\' OR employment_type:\'Part Time\''

const filtersBuilder = {
  categories: categories =>
    categories.length
      ? `(${compose(
        join(' OR '),
        map(category => `job_category:'${category}'`)
      )(categories)})`
      : '',
  salaryRange: ({ baseCompMin }) =>
    baseCompMin
      ? `(annual_compensation_min.value >= ${baseCompMin} OR annual_compensation_max.value >= ${baseCompMin})`
      : '',
  locations: locations =>
    locations.length
      ? `(${compose(
        join(' OR '),
        map(location => `facilities.state_name:'${trim(location.code)}' OR other_states:'${trim(location.code)}'`)
      )(locations)})`
      : '',
  seasonal: seasonal =>
    seasonal
      ? `(employment_type:Seasonal OR employment_type:seasonal OR ${DEFAULT_EMPLOYMENT_FILTERS})`
      : `(${DEFAULT_EMPLOYMENT_FILTERS})`,
  excludeProOnly: shouldExclude =>
    shouldExclude
      ? '(NOT applicant_group: \'PGA Professional Only\')'
      : ''
}

const buildFiltersFrom = compose(
  join(' AND '),
  filter(trim),
  map(([paramKey, paramValue]) => filtersBuilder[paramKey](paramValue)),
  toPairs
)

const buildAlgoliaQuery = ({ queryParams, created, hitsPerPage = 10 }) => {
  const filters = buildFiltersFrom(queryParams)
  if (filters === `(${DEFAULT_EMPLOYMENT_FILTERS})`) return null
  return {
    hitsPerPage,
    page: 0,
    attributesToRetrieve: [
      'jobId',
      'jobTitle',
      'created',
      'facilities',
      'job_category',
      'base_compensation',
      'current_step'
    ],
    responseFields: '*',
    filters: `${filters} ${
      filters ? 'AND' : ''
    } submission_deadline > ${Date.now() / 1000} AND current_step:"complete" ${created ? `AND (created > ${created} OR mgmt_job_go_live_datetime > ${created})` : ''}`
  }
}

module.exports = {
  buildAlgoliaQuery,
  buildFiltersFrom,
  filtersBuilder
}
